import $ from "jquery";
const formLabels = () => {
    function floatingLabels() {
        $(".gform_wrapper input, .gform_wrapper textarea").on(
            "change keyup keydown paste cut",
            function () {
                var value = $(this).val();
                if (value == "") {
                    $(this).parents(".gfield").removeClass("has-value");
                } else {
                    $(this).parents(".gfield").addClass("has-value");
                }
            }
        );
    }
    floatingLabels();

    $(document).on("gform_post_render", function (e, form_id) {
        if (jQuery(".gform_validation_error").length > 0) {
            $.each(
                $(".gform_wrapper input, .gform_wrapper textarea"),
                function () {
                    var value = $(this).val();

                    if (value == "") {
                        $(this).parents(".gfield").removeClass("has-value");
                    } else {
                        $(this).parents(".gfield").addClass("has-value");
                    }
                }
            );

            floatingLabels();
        }
    });
};

export default formLabels;
